import type { Place } from '../../models/Place.d.ts';
import type { SupabaseClient } from '@supabase/supabase-js';
import { SupabaseRepository } from '../supabaseRepository/SupabaseRepository.ts';

const selector = `id, day, name, country, city, itinerary_id, data, is_generating, failed_generation, created_at`;

export class PlaceRepository extends SupabaseRepository<Place> {
  constructor(client: SupabaseClient) {
    super('places', selector, client);
  }
}
